import { JSX } from 'react';

import { Icon, Text } from '@videoblocks/design-system';

export const HoverOverlay = (): JSX.Element => {
    return (
        <div
            data-testid="hover-overlay"
            className="absolute inset-0 flex flex-col items-center justify-center gap-6 bg-black/50 hover:cursor-pointer"
        >
            <div className="flex size-[60px] items-center backdrop-blur-xl justify-center rounded-full bg-white/10 transition-colors inset-shadow-[0px_0px_1px_rgba(255,255,255,.6)] hover:cursor-pointer">
                <Icon
                    name="plus"
                    className="[&_path]:fill-white"
                    width={24}
                    height={24}
                    data-testid="hover-overlay-plus-icon"
                />
            </div>
            <Text fontSize="sm" fontWeight="semibold" className="w-full text-center">
                Generate video from this image
            </Text>
        </div>
    );
};
